import React from "react";

/**
 * Pass 16 — conditional won-deal economics inputs.
 *
 * Renders two optional fields (Won Value MYR + Sold Watch / SKU) only
 * when the parent status select is on "Closed Won". The parent owns the
 * state and the controlled values; this component is presentational.
 *
 * NB: SKU auto-prefill from Product_Watch lives in the PARENT's status
 * onChange handler, not here — that path is synchronous and avoids the
 * React 18 strict-mode useEffect render-race the prior implementation
 * triggered. See AdminLeads / StaffPanel / UpdateLead for the wiring.
 */
export default function WonDealFields({
  visible,
  wonValue,
  wonSku,
  onChangeValue,
  onChangeSku,
  readOnly = false,
}) {
  if (!visible) return null;

  return (
    <div
      style={{
        background: "#fafafa",
        border: "1px solid var(--scw-line)",
        padding: "16px 18px",
        marginBottom: 22,
      }}
      data-testid="won-deal-fields"
    >
      <p
        className="scw-eyebrow"
        style={{ marginBottom: 12, fontSize: 11, letterSpacing: "0.16em" }}
      >
        Closed Won &middot; {readOnly ? "recorded details" : "optional details"}
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <div>
          <label className="scw-label">Won value (MYR)</label>
          <input
            className="scw-input"
            type="text"
            inputMode="decimal"
            value={wonValue}
            onChange={(e) => onChangeValue(e.target.value)}
            placeholder="e.g. 45000"
            readOnly={readOnly}
            disabled={readOnly}
            data-testid="won-value-input"
          />
        </div>
        <div>
          <label className="scw-label">Sold watch / SKU</label>
          <input
            className="scw-input"
            type="text"
            value={wonSku}
            onChange={(e) => onChangeSku(e.target.value)}
            placeholder="e.g. Rolex Submariner 126610LN"
            readOnly={readOnly}
            disabled={readOnly}
            data-testid="won-sku-input"
          />
        </div>
      </div>
      {!readOnly && (
        <p
          style={{
            fontSize: 11,
            color: "var(--scw-muted)",
            marginTop: 10,
            marginBottom: 0,
          }}
        >
          Both fields are optional. The win date is recorded automatically.
        </p>
      )}
    </div>
  );
}
